'use client';

import { useAppTranslation } from 'app/hooks';
import { StakingStatus, UserStakingResponse } from 'models/stake';
import { formatAmountV2 } from 'utils/formatAmount';
import { formatDateNoTime } from 'utils/dateUtils';
import { Tooltip } from 'antd';
import { FaEye, FaTimes } from 'react-icons/fa';
import { useState } from 'react';
import ClaimHistoryModal from './ClamHistoryModal';
import stakingApi from 'api/stakingApi';
import { showConfirmModal, showSuccessModal } from 'components/Modals/CommonModals';
import InfomationIcon from 'assets/icons/InfomationIcon';

interface StakingHistoryItemProps {
  item: UserStakingResponse;
  fetch: () => Promise<void>;
}

const StakingHistoryItem: React.FunctionComponent<StakingHistoryItemProps> = ({ item, fetch }) => {
  const t = useAppTranslation();
  const [isShowModal, setIsShowModal] = useState<boolean>(false);

  const onCancelStaking = async () => {
    const { ok } = await stakingApi.cancelStaking(item.id);
    if (ok) {
      showSuccessModal({
        content: t('staking-history.success'),
        onOk: () => fetch(),
      });
    }
  };

  const showConfirmCancel = () => {
    if (item.status === StakingStatus.CANCEL) {
      return;
    }
    showConfirmModal({
      content: <p>{t('staking-history.cancel-title')}</p>,
      width: 360,
      icon: <InfomationIcon />,
      onOk: onCancelStaking,
      okText: t('sharebet.popup.button-ok'),
      cancelText: t('sharebet.popup.button-cancel'),
    });
  };

  return (
    <div className="transaction">
      <div className="row">
        <span>{t('staking-history.header.id')}</span>
        <span className="font-bold">{item.id}</span>
      </div>
      <div className="row">
        <span>{t('staking-history.header.vault-name')}</span>
        <span>{item.stakingVaultDto.label}</span>
      </div>
      <div className="row">
        <span>{t('staking-history.header.day-number')}</span>
        <span>{item.stakingVaultDto.dayNumber}</span>
      </div>
      <div className="row">
        <span>{t('staking-history.header.reward-percent')}</span>
        <span>{item.stakingVaultDto.rewardPercent}%</span>
      </div>
      <div className="row">
        <span>{t('staking-history.header.status')}</span>
        <span
          className={item.status === StakingStatus.CANCEL ? 'staking-cancel' : 'staking-progress'}
        >
          {item.status}
        </span>
      </div>
      <div className="row">
        <span>{t('staking-history.header.stake-amount')}</span>
        <span>{formatAmountV2(item.stakeAmount, 2)} $TBET</span>
      </div>
      <div className="row">
        <span>{t('staking-history.header.next-claim-date')}</span>
        <span>{formatDateNoTime(item.claimDate)}</span>
      </div>
      <div className="row">
        <span>{t('staking-history.header.action')}</span>
        <div className="flex-row staking-action">
          <Tooltip
            placement={'bottom'}
            title={t('staking-history.header.claim-history')}
            color="#636363"
            showArrow={false}
          >
            <div className="referral-detail-btn " onClick={() => setIsShowModal(true)}>
              <FaEye />
            </div>
          </Tooltip>
          <Tooltip
            placement={'bottom'}
            title={t('staking-history.header.cancel')}
            color="#636363"
            showArrow={false}
          >
            <div
              className={`referral-detail-btn-cancel ${
                item.status === StakingStatus.CANCEL ? 'disabled' : ''
              }`}
              onClick={showConfirmCancel}
            >
              <FaTimes />
            </div>
          </Tooltip>
        </div>
      </div>
      <ClaimHistoryModal item={item} visible={isShowModal} onCancel={() => setIsShowModal(false)} />
    </div>
  );
};

export default StakingHistoryItem;
